import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import ActivityCalendarModule from 'app_components/modules/campus/academic/activityCalendar'
import UserInfoModule from 'app_components/modules/campus/user/userInfo'
import { PostLocations } from 'app_types/campus/postTypes'
import React, { FC, useEffect, useMemo, useState } from 'react'
import NewsList from './components/NewsList/NewsList'
import { ButtonGroup, ToggleButton } from 'react-bootstrap'

import './StudentDashboardPage.scss'
import StudentsDashboardCurrentCourses from './components/StudentsDashboardCurrentCourses/StudentsDashboardCurrentCourses'
import StudentsDashboardHistoryCourses from './components/StudentsDashboardHistoryCourses/StudentsDashboardHistoryCourses'
import StudentDashboardCertifications from './components/StudentDashboardCertifications/StudentDashboardCertifications';
import InteractionService from 'app_services/interaction/interactionService'
import StudentDashboardRelatedCourses from './components/StudentDashboardRelatedCourses/StudentDashboardRelatedCourses'
import RouterService from 'app_services/router/routerService'
import { useLocation } from 'react-router-dom'

export enum STUDENT_DASHBOARD_TAB {
  CURRENT = 'current',
  HISTORY = 'history',
  CERTIFICATIONS = 'certifications',
}

const StudentDashboardPage: FC = () => {
  const [menuSelected, setMenuSelected] = useState('1');
  const menus = useMemo(() => [
    { name: 'En curso', value: '1', status: 'enabled', id: 'student_dashboard_currents_tab' },
    { name: 'Terminados', value: '2', status: 'enabled', id: 'student_dashboard_history_tab' },
    { name: 'Certificados', value: '3', status: 'enabled', id: 'student_dashboard_certifications_tab' },
  ], [])
  const interactionService = useMemo(() => new InteractionService(), [])
  const location = useLocation()
  const routerService = useMemo(() => new RouterService(), [])

  useEffect(() => {
    const params = routerService.getParamsURLObject()
    const section = params?.section
    if (section?.trim()?.length) {
      switch(section) {
        case 'certifications':
          setMenuSelected('3')
          break;
        default:
          break;
      }
    }
  }, [routerService, location?.search])

  useEffect(() => {
    interactionService.checkSurveyAvailable()
    interactionService.checkPendingCertificationsWithPayment()
    interactionService.checkHelpStepsInteraction()
    interactionService.checkProfileInformation()
  }, [interactionService])

  return (
    <div className='student-dashboard--layout'>
      <div className="students-dashboard--background"/>
      <div className="student-dashboard--main-layout">
        <div>
          <UserInfoModule
            id="student_dashboard_user_info"
            className='student-dashboard--user-info'
            hideCertifications
            showEditButton
            showChangePassword
          />
          <NewsList id="student_dashboard_news" location={PostLocations.STUDENT} />
          <div className='student-dashboard--calendar'>
            <TextComponent type="subtitle">Calendario</TextComponent>
            <ActivityCalendarModule />
          </div>
        </div>
        <div>
          <TextComponent type='title' className='student-dashboard--title'>Mi cuenta</TextComponent>
          <div className="student-dashboard--tabs">
            <ButtonGroup toggle style={{ width: '100%' }}>
              {menus.map((radio, idx) => (
                <ToggleButton
                  key={idx}
                  type="radio"
                  variant="secondary"
                  name="radio"
                  value={radio.value}
                  checked={menuSelected === radio.value}
                  onChange={(e) => setMenuSelected(e.currentTarget.value)}
                  disabled={radio.status === 'disabled'}
                  id={radio.id}
                >
                  {radio.name}
                </ToggleButton>
              ))}
            </ButtonGroup>
          </div>
          {menuSelected === '1' && (<StudentsDashboardCurrentCourses />)}
          {menuSelected === '2' && (<StudentsDashboardHistoryCourses />)}
          {menuSelected === '3' && (<StudentDashboardCertifications />)}
          <StudentDashboardRelatedCourses id="student_dashboard_related_courses" />
        </div>
      </div>
    </div>
  )
}

export default StudentDashboardPage
